export const PREFIX = 'COMMON'
export const CONST = (value) => (PREFIX + '_' + value)
export const SYSTEM_FETCH_KENMEI_CODES = CONST('SYSTEM_FETCH_KENMEI_CODES')
export const REDUCER_SET_KENMEI_CODES = CONST('REDUCER_SET_KENMEI_CODES')

export const systemFetchKenmeiCodes = () => ({
  type: SYSTEM_FETCH_KENMEI_CODES,
  payload: {
  }
})

export const reducerSetKenmeiCodes = (kenmeiCodes) => ({
  type: REDUCER_SET_KENMEI_CODES,
  payload: {
    kenmeiCodes: kenmeiCodes,
  }
})



// WEBPACK FOOTER //
// ./src/actions/common.js